const phrases = {
  home: [
    "O que quer fazer hoje?",
    "Bem-vindo de volta!",
    "Escolha uma das opções abaixo para continuar.",
    "Vamos colocar as ideias em prática?"
  ],
  empresas: [
    "Selecione uma empresa para edição.",
    "Cadastre uma nova empresa.",
    "Gerencie suas empresas com facilidade.",
    "Clique em uma empresa para visualizar suas turmas."
  ],
  turmas: [
    "Veja as turmas disponíveis nesta empresa.",
    "Clique em uma turma para acessar os detalhes.",
    "Você pode editar ou excluir turmas existentes.",
    "Adicione uma nova turma para esta empresa."
  ],
  participantes: [
    "Aqui estão os participantes dessa turma.",
    "Adicione, edite ou apenas observe!",
    "Um time completo começa com bons participantes.",
    "Cada nome aqui é uma história esperando para começar."
  ],
  testes: [
    "Gerencie os testes disponíveis na plataforma.",
    "Teste dado é teste aplicado!",
    "Crie, edite e organize seus testes com tranquilidade.",
    "Preparar, apontar... testando!"
  ],
  produtos: [
    "Aqui ficam os produtos disponíveis.",
    "Tudo sob controle? Seus produtos também estão!",
    "Adicione novos produtos e mantenha o estoque em dia.",
    "Organizar produtos nunca foi tão fácil (nem divertido)!"
  ],
  videos: [
    "Gerencie os vídeos disponíveis na plataforma.",
    "Hora do show! Veja os vídeos cadastrados.",
    "Adicione vídeos para turbinar sua apresentação.",
    "Luz, câmera... organização!"
  ],
  usuarios: [
    "Gerencie os usuários cadastrados no sistema.",
    "Clique em um usuário para visualizar detalhes.",
    "Adicione um novo usuário à plataforma.",
    "Mantenha os dados dos usuários sempre atualizados."
  ],
  adicionarEmpresa: [
    "Preencha com os dados da empresa.",
    "Preencha os dados solicitados.",
    "A identidade da empresa começa aqui!",
    "Vamos colocar essa empresa no mapa?"
  ],
  adicionarTurma: [
    "Preencha com os dados da turma.",
    "Preencha os dados solicitados.",
    "Organize seu conteúdo com turmas eficientes.",
    "Turma nova, oportunidades novas!"
  ],
  adicionarParticipante: [
    "Preencha com os dados do participante.",
    "Quem entra para o time agora?",
    "Cada participante conta — literalmente!",
    "Complete os campos e bora somar mais um!"
  ],
  adicionarUsuario: [
    "Preencha com os dados do usuário.",
    "Hora de dar boas-vindas a um novo usuário!",
    "Quem está chegando por aqui?",
    "Mais um para o time — vamos nessa!"
  ],
  adicionarTeste: [
    "Preencha com os dados do teste.",
    "É hora de montar aquele teste caprichado!",
    "Com grandes testes vêm grandes responsabilidades.",
    "Teste criado, desafio lançado!"
  ],
  adicionarVideo: [
    "Preencha com os dados do vídeo.",
    "Hora de dar play na sua biblioteca!",
    "Um vídeo vale mais que mil slides.",
    "Compartilhe conhecimento em forma de pixels!"
  ],
  adicionarProduto: [
    "Preencha com os dados do produto.",
    "Qual produto vai brilhar hoje?",
    "Tudo pronto para mais um item no catálogo!",
    "Produto novo, oportunidade nova!"
  ],
  atualizarEmpresa: [
    "Preencha com os dados da empresa.",
    "Preencha os dados solicitados.",
    "Hora de deixar tudo atualizado!",
    "Empresa renovada, dados em dia!"
  ],
  atualizarTurma: [
    "Preencha com os dados da turma.",
    "Preencha os dados solicitados.",
    "Atualize a turma e mantenha tudo sob controle.",
    "Mudou? Sem problema, é só ajustar aqui!"
  ],
  atualizarParticipante: [
    "Atualize os dados do participante.",
    "Todo mundo muda — até os dados!",
    "Mantenha as informações sempre em dia.",
    "Ajuste rápido, resultado certeiro."
  ],
  atualizarUsuario: [
    "Atualize os dados do usuário.",
    "Nome novo, senha nova? Aqui é o lugar!",
    "Atualize e siga tranquilo.",
    "Usuário renovado com sucesso!"
  ],
  atualizarTeste: [
    "Atualize os dados do teste.",
    "Revise as perguntas e dê aquele toque final.",
    "Quem disse que teste não pode evoluir?",
    "Ajuste seu teste para ficar tinindo!"
  ],
  atualizarVideo: [
    "Atualize os dados do vídeo.",
    "Deu pau no link? Aqui você conserta.",
    "A hora da edição chegou!",
    "Vídeo atualizado, conteúdo garantido!"
  ],
  atualizarProduto: [
    "Atualize os dados do produto.",
    "Produto com cara nova? Atualize aqui.",
    "Deixe tudo certinho para o cliente.",
    "Informações fresquinhas e atualizadas!"
  ],
  participanteRespostas: [
      "Aqui estão os resultados dos testes do participante.",
      "Cada resposta conta uma parte da jornada!",
      "Revise os resultados para acompanhar a evolução.",
      "Se quiser, pode possibilitar que um teste seja refeito — é só excluir a resposta anterior.",
  ],
  institucional: [
    "Descubra o que torna nossa história tão especial.",
    "Aqui você encontra o vídeo e a descrição institucional.",
    "Tudo sobre quem somos — em palavras e imagens.",
    "Nossa essência em poucos segundos (ou parágrafos)!"
  ],
  atualizarInstitucional: [
    "Atualize o conteúdo institucional com confiança!",
    "Novo vídeo? Nova descrição? Aqui é o lugar!",
    "Mantenha sua apresentação institucional sempre atualizada.",
    "Cada ajuste aqui fortalece sua identidade institucional."
  ],
  algoritmos: [
    "Aqui estão os algoritmos já criados.",
    "Todos os algoritmos cadastrados, organizados para consulta rápida.",
    "Use títulos e versões para encontrar exatamente o que você precisa.",
    "Mantenha a biblioteca limpa: arquive ou remova versões que não fazem mais sentido."
  ],
  scoringSpecForm: [
    "Ajuste pesos e perfis — seu algoritmo toma forma aqui.",
    "Use tuplas para somar forças entre perguntas e reforçar perfis.",
    "Crie grupos por intervalo de questões e opções para ver resultados por bloco.",
    "Valide e salve: o preview mostra se está tudo redondinho."
  ],

  // Adicione mais frases conforme necessário
};

export default phrases;